// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterMenuContent_root__27isq"};